import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/*
 * Returns true when a given array includes a given specific string.
 * Otherwise, returns false.
 */
@Pipe({
    name: 'arrayIncludes', pure: true,
    standalone: false
})
export class ArrayIncludesPipe implements PipeTransform {
  constructor(public translate: TranslateService) {}
  transform(array: string[] = [], expected: string): boolean {
    return array?.includes(expected) ?? false;
  }
}
